<script setup>
import { ref } from "vue";
import { Widget, Button, Description } from "@statamic/cms/ui";

const props = defineProps({
  apiUrl: String,
  subsidiesUrl: String,
});

const loading = ref(false);

async function clearCache() {
  loading.value = true;
  try {
    const response = await fetch("/cp/subsidies/cache-clear");
    if (response.ok) {
      Statamic.$toast.success("Tilskudscache ryddet");
    } else {
      Statamic.$toast.error("Kunne ikke rydde cache");
    }
  } finally {
    loading.value = false;
  }
}
</script>

<template>
  <Widget title="Administrer tilskud">
    <div class="space-y-4 px-4 py-3">
      <ul
        class="list-outside list-disc space-y-1.5 pl-4 text-sm text-gray-600/90 dark:text-gray-400"
      >
        <li>
          Opret nye og administrer
          <a
            href="/cp/collections/subsidy_blocks"
            class="text-primary hover:underline"
            >tilskudsblokke her</a
          >, vist i top og bund på tilskudssider.
        </li>
        <li>
          Når man skal tilgå en specifik version, så tilgås den ved at sende
          version med i url'en:<br />
          <code
            class="mt-1 inline-block rounded border border-gray-200 bg-gray-100 px-1.5 py-0.5 text-xs dark:border-gray-700 dark:bg-gray-900"
          >
            {{ subsidiesUrl }}?version=2200.001
          </code>
        </li>
      </ul>

      <div class="flex justify-center">
        <Button
          variant="primary"
          :loading="loading"
          :disabled="loading"
          @click="clearCache"
          text="Ryd cachen for tilskud"
        />
      </div>

      <Description class="text-center">
        Fetching subsidies from: {{ apiUrl }}
      </Description>
    </div>
  </Widget>
</template>
